'use client';

import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useInitLanding } from '@/api/useInitLanding';
import { generateUUID } from '@/lib/polyfills';

export default function TpSessionHandler() {
  const { initLanding } = useInitLanding();

  useEffect(() => {
    const captureTrafficData = async () => {
      const params = new URLSearchParams(window.location.search);
      const utmSource = params.get('utm_source');
      const utmMedium = params.get('utm_medium');
      const utmCampaign = params.get('utm_campaign');
      const utmContent = params.get('utm_content');
      const referrer = document.referrer || null;

      // Basic device type detection
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent);
      const deviceType = isMobile ? 'mobile' : 'desktop';

      // Set a cookie and proceed only if not already existing
      if (
        Cookies.get(process.env.NEXT_PUBLIC_TRAFFIC_SOURCES_COOKIE_NAME || 'trovanorma_tpSessionId')
      ) {
        return;
      }
      const tpSessionId = generateUUID();

      const trafficData = {
        tpSessionId,
        deviceType,
        utmSource,
        utmMedium,
        utmCampaign,
        utmContent,
        referrer,
      };

      try {
        await initLanding(trafficData);
        // Set cookies only after they have been sent to server
        Cookies.set(
          process.env.NEXT_PUBLIC_TRAFFIC_SOURCES_COOKIE_NAME || 'trovanorma_tpSessionId',
          tpSessionId,
          {
            expires: 365,
            domain: process.env.NEXT_PUBLIC_TRAFFIC_SOURCES_COOKIE_DOMAIN || '.trovanorma.it',
          }
        );
        Cookies.set(
          process.env.NEXT_PUBLIC_UTM_SOURCE_COOKIE_NAME || 'trovanorma_initialUtmSource',
          utmSource || 'direct',
          {
            expires: 30,
            domain: process.env.NEXT_PUBLIC_TRAFFIC_SOURCES_COOKIE_DOMAIN || '.trovanorma.it',
          }
        );
      } catch (error) {
        console.error('Error initializing TPSession:', error);
      }
    };

    //if (!sessionStorage.getItem('trovanorma_initialTPSession')) {
    captureTrafficData();
    //sessionStorage.setItem('trovanorma_initialTPSession', 'true');
    //}
  }, [initLanding]);

  return null; // This component doesn't render any UI
}
